import _implicitStylesheets from "./titledGroup.css";
import _implicitScopedStylesheets from "./titledGroup.scoped.css?scoped=true";
import _wdsPopoverTooltip from "wds/popoverTooltip";
import _wdsBadge from "wds/badge";
import _axBadge from "ax/badge";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span${"a0:type-style"} class="grouptitle${0}"${"a0:role"}${"a0:aria-level"}${2}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "titled-group": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "section-title-container": true
  },
  key: 1
};
const stc2 = {
  "tooltip-container": true
};
const stc3 = {
  classMap: {
    "elements-container": true
  },
  key: 5
};
const stc4 = {
  classMap: {
    "elements-list": true
  },
  attrs: {
    "role": "list"
  },
  key: 6
};
const stc5 = {
  "element-wrapper": true
};
const stc6 = {
  "role": "listitem"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, k: api_key, i: api_iterator} = $api;
  return [api_element("dl", stc0, [api_element("dt", stc1, [api_static_fragment($fragment1, 3, [api_static_part(0, {
    attrs: {
      "type-style": $cmp.titleTypeStyle,
      "role": $cmp.titleRole,
      "aria-level": $cmp.titleAriaLevel
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.title))]), $cmp.tooltip ? api_custom_element("wds-popover-tooltip", _wdsPopoverTooltip, {
    classMap: stc2,
    props: {
      "tooltipData": $cmp.tooltip,
      "popoverOrientation": $cmp.tooltipOrientation,
      "flipIfOverflowsViewport": $cmp.flipIfOverflowsViewport,
      "ariaLabel": $cmp.tooltipAriaLabel
    },
    key: 4
  }) : null]), api_element("dd", stc3, [api_element("div", stc4, api_iterator($cmp.badges, function (badge) {
    return api_element("div", {
      classMap: stc5,
      attrs: stc6,
      key: api_key(7, badge.iteratorKey)
    }, [badge.i18nFn ? api_custom_element("wds-badge", _wdsBadge, {
      props: {
        "badge": badge
      },
      key: 8
    }) : null, !badge.i18nFn ? api_custom_element("ax-badge", _axBadge, {
      props: {
        "text": badge.value,
        "theme": badge.variant
      },
      key: 9
    }) : null]);
  }))])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-8qqpvk35t3";
tmpl.legacyStylesheetToken = "undefined-_titledGroup";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
